import Vue from 'vue'
import Router from 'vue-router'
import container from '@/page/mail/container'
import contactRouter from '@/router/contact'
import settingRouter from '@/router/setting'
import vipRouter from '@/router/vip'
import mailRouter from '@/router/mail'
import loginRouter from '@/router/login'
import homepageRouter from '@/router/homepage'
import promptRouter from '@/router/prompt'
import helpRouter from '@/router/help'
import attachRouter from '@/router/attach'
import readMail from '@/page/mail/readMail'

Vue.use(Router)

const router = new Router({
    'linkActiveClass': 'active',
    'routes': [
        ...loginRouter, 
        ...promptRouter,
        ...helpRouter,
        {
            path: '/readMail',
            name: 'readMail',
            component: readMail
        },
        {
        path: '/',
        name: 'container',
        component: container,
        children: [
            contactRouter,
            settingRouter,
            attachRouter,
            ...mailRouter,
            ...vipRouter,
            ...homepageRouter
        ]
    }]
})

router.beforeEach((to, from, next) => {
    let pages = ['login', 'register', 'appeal', 'mediate', 'forgetpwd', 'help', 'registercard']
    $('html').css('overflow', ~pages.indexOf(to.name) ? 'auto' : 'hidden')
    next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js